import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GenericDatepickerComponent } from '../components/generic-datepicker/generic-datepicker.component';
import { GenericDateTimePickerComponent } from '../components/generic-datetimepicker/generic-datetimepicker.component';
import { GenericAutocompleteComponent } from '../components/generic-autocomplete/generic-autocomplete.component';
import { IdbaLookupAutocompleteComponent } from '../components/idba-lookup-autocomplete/idba-lookup-autocomplete.component';
import { GenericMultiAutocompleteComponent } from '../components/generic-multi-autocomplete/generic-multi-autocomplete.component';
import { IdbaMatTableCellComponent } from '../components/idba-mat-table-cell/idba-mat-table-cell';
import { IdbaMatTableFooterComponent } from '../components/idba-mat-table-footer/idba-mat-table-footer';
import { FilterFieldComponent } from '../components/filter-field/filter-field.component';
import { FieldErrorMessageComponent } from '../components/forms/field-error-message/field-error-message.component';
import { ResponsiveMatTableComponent } from '../components/responsive-mat-table/responsive-mat-table.component';

export const MATERIAL_FORM = [
  ReactiveFormsModule,
  FormsModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatAutocompleteModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatCheckboxModule,
  MatRadioModule,
  MatSlideToggleModule,
  MatSliderModule,
  GenericAutocompleteComponent,
  IdbaLookupAutocompleteComponent,
  GenericMultiAutocompleteComponent,
  GenericDatepickerComponent,
  GenericDateTimePickerComponent,
];

export const MATERIAL_LAYOUT = [
  MatCardModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatListModule,
  MatSidenavModule,
  MatTabsModule,
  MatToolbarModule,
  MatStepperModule,
  MatDialogModule,
  MatRippleModule,
];

export const MATERIAL_BUTTONS = [
  MatButtonModule,
  MatButtonToggleModule,
  MatMenuModule,
  MatChipsModule,
];

export const MATERIAL_FEEDBACK = [
  MatSnackBarModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatTooltipModule,
  MatBadgeModule,
  MatBottomSheetModule,
];

export const MATERIAL_DATA = [
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatTreeModule,
  IdbaMatTableCellComponent,
  IdbaMatTableFooterComponent,
  ResponsiveMatTableComponent,
];

export const CDK_MODULES = [CdkStepperModule, CdkTableModule, CdkTreeModule];

export const ESSENTIALS = [CommonModule, FlexLayoutModule, MatIconModule, RouterModule];
export const ESSENTIALS_LIST = [
  ESSENTIALS,
  MATERIAL_DATA,
  MATERIAL_FORM,
  MATERIAL_BUTTONS,
  MATERIAL_FEEDBACK,
  MATERIAL_LAYOUT,
  FilterFieldComponent,
];

export const ESSENTIALS_FORM = [
  ESSENTIALS,
  MATERIAL_FORM,
  MATERIAL_BUTTONS,
  MATERIAL_FEEDBACK,
  MATERIAL_LAYOUT,
  FieldErrorMessageComponent,
];
